import { render } from "./LoadClassesIcon.vue?vue&type=template&id=560b6ca8"
import script from "./LoadClassesIcon.vue?vue&type=script&lang=js"
export * from "./LoadClassesIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__